import { useMemo } from 'react';
import useFieldValidation from 'hooks/useFieldValidation';
function getFieldLabel(name, t) {
    switch (name) {
        case 'name':
            return t('size_name_capitalized');
        case 'sizes':
            return t('sizes');
        default:
            return name;
    }
}
function getFieldError(name, sizeStandard, sizeNames, t) {
    if (name === 'name')
        return !(sizeStandard === null || sizeStandard === void 0 ? void 0 : sizeStandard.trim()) ? t('required_field') : null;
    if (name === 'sizes')
        return sizeNames.length === 0 ? t('required_field') : null;
    return null;
}
function useSizeCreatorValidation(sizeStandard, sizeNames, t) {
    const validatedFields = useMemo(() => ['name', 'sizes'], []);
    return useFieldValidation(validatedFields, (field) => getFieldError(field, sizeStandard, sizeNames, t), (field) => getFieldLabel(field, t));
}
export default useSizeCreatorValidation;
